export default "__VITE_ASSET__98ffb9cc__"